<template>
  <div>
    <div>
      <el-header v-if="top_disp==true">
        <!-- 首页头部 -->
        <homeTop></homeTop>
      </el-header>
    </div>
    <div>
      <el-main>
        <!-- 出口 -->
        <router-view class="content"></router-view>
      </el-main>
    </div>
    <div>
      <el-footer v-if="bottom_disp==true">
        <!-- 首页底部 -->
        <homeBottom></homeBottom>
      </el-footer>
    </div>
  </div>
</template>
<script src="/static/rem.js"></script>
<script>
import homeTop from "./homeTop.vue";
import homeBottom from "./homeBottom.vue";
// import global from "@/global/global.js";
import eventBus from "@/api/eventBus.js";
export default {
  components: {
    homeTop,
    homeBottom,
  },
  data() {
    return {
      top_disp:true,
      bottom_disp:true,
    };
  },
  created(){
    eventBus.$on('ENTER_HOUTAI', (data)=> {
          console.log(data);
          if (data ==  1) {
            this.top_disp = true;
            this.bottom_disp = true;
          } else if (data == 0) {
            this.top_disp = false;
            this.bottom_disp = false;
          }
      });
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped >
.home-container {
  width: 100%;
  margin: 0 auto;
  display: flex;
   position: relative;

  .content {
    flex: 1;
    background-color: #fff;
  }
}
</style>